import MuiLink from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import usePromise from 'hooks/usePromise';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';

const padding = {
  large: 9,
  medium: 7,
  small: 5,
  mini: 3,
};

const StyledIconButton = styled(Button, {
  shouldForwardProp(propName) {
    return propName !== 'rounded';
  },
})(({ size = 'medium', variant, color, rounded }) => {
  let buffer = ['contained', 'text'].includes(variant) ? 1 : 0;

  return {
    minWidth: 0,
    paddingLeft: padding[size] + buffer,
    paddingRight: padding[size] + buffer,
    borderRadius: rounded ? '50%' : undefined,
    '&.MuiButton-containedSecondary': {
      padding: padding[size],
    },
  };
});

const IconButton = React.forwardRef(
  ({ icon, to, href, title, loading, onClick, ...rest }, ref) => {
    const [isLoading, handler] = usePromise(onClick, loading);

    let children = (
      <StyledIconButton
        variant="contained"
        loading={isLoading}
        onClick={handler}
        color="secondary"
        ref={ref}
        {...rest}
      >
        {icon}
      </StyledIconButton>
    );

    if (title) {
      children = (
        <Tooltip arrow title={title}>
          {children}
        </Tooltip>
      );
    }

    if (to) {
      return (
        <MuiLink component={Link} to={to} {...rest}>
          {children}
        </MuiLink>
      );
    } else if (href) {
      return (
        <MuiLink href={href} {...rest}>
          {children}
        </MuiLink>
      );
    }
    return children;
  },
);

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text', 'tonal']),
};

export default IconButton;
